import React, {
    ReactElement, useEffect, useState,
} from "react";
import { Form } from "react-bootstrap";

import {
    ChatSettingsChannelEmail,
    ChatSettingsChannelEmailInput,
} from "../../../../../__generated__/api";
import Editor from "../../../../../components/editor/Editor";
import BooleanSelect from "../../../../../components/pickers/boolean/BooleanSelect";

export interface Props {
    data?: ChatSettingsChannelEmail,
    onChange: (menu: ChatSettingsChannelEmailInput) => void;
}

export default function EmailSettings({ data, onChange }: Props): ReactElement {
    const [shouldSendFeedback, setShouldSendFeedback] = useState(data?.shouldSendFeedback);
    const [feedbackIntroduction, setFeedbackIntroduction] = useState(data?.feedbackIntroduction);

    useEffect(() => {
        setShouldSendFeedback(data?.shouldSendFeedback);
        setFeedbackIntroduction(data?.feedbackIntroduction);
    }, [data?.shouldSendFeedback, data?.feedbackIntroduction]);

    useEffect(() => {
        if (shouldSendFeedback !== data?.shouldSendFeedback || feedbackIntroduction !== data?.feedbackIntroduction) {
            onChange({
                feedbackIntroduction,
                shouldSendFeedback,
                name: data?.name,
            });
        }
    }, [shouldSendFeedback, feedbackIntroduction]);

    return (
        <div className="border p-3 roundjed bg-white mt-4">
            <h5 className="mb-3 text-light">

                Email
                {" "}
                {data?.name ? (
                    <>
                        (
                        {data.name}
                        )
                    </>
                ) : ""}
            </h5>

            <Form.Group className="mt-4">
                <Form.Label className="fw-bolder">Send Feedback</Form.Label>

                <BooleanSelect
                    className="border border-gray rounded"
                    value={shouldSendFeedback ?? false}
                    onChange={value => setShouldSendFeedback(value ?? false)}
                />
                <Form.Text>
                    This message will automatically be added to the bottom of each email
                </Form.Text>
            </Form.Group>

            {shouldSendFeedback && (
                <Form.Group className="mt-4">
                    <Form.Label className="fw-bolder">
                        Feedback Introduction
                        {" "}
                        <span className="text-light">(Optional)</span>
                    </Form.Label>

                    <Editor
                        className="border border-gray rounded"
                        text={feedbackIntroduction ?? ""}
                        onChange={msg => setFeedbackIntroduction(msg)}
                        placeholder="The conversation is closed..."
                    />
                    <Form.Text>
                        This message will appear at the top of the feedback email.
                    </Form.Text>
                </Form.Group>
            )}
        </div>
    );
}

EmailSettings.defaultProps = {
    data: undefined,
};
